import i18n from 'src/i18n';
import { Box, Button, Card, Chip, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { CommonHelper } from 'src/utils/commonHelper';

export default function IntegrationCard({ channel, onWhatsAppConnect }) {
  const { t: translate } = useTranslation();
  const Icon = channel.Icon;
  const planBlocked = channel.key === 'whatsapp' && !CommonHelper.HasProfessionalPlan();
  const comingSoonLabel = translate('integrations.coming_soon', { defaultValue: 'Coming Soon' });

  return (
    <Card
      variant="outlined"
      sx={(theme) => ({
        height: '100%',
        p: 3,
        borderRadius: 1,
        borderColor: alpha(channel.color, 0.24),
        backgroundColor: theme.palette.background.paper,
        boxShadow: `0 16px 40px ${alpha(channel.color, 0.08)}`,
      })}
    >
      <Stack spacing={2.5} height="100%">
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: 1,
              display: 'grid',
              placeItems: 'center',
              color: channel.color,
              backgroundColor: alpha(channel.color, 0.1),
            }}
          >
            <Icon />
          </Box>
          {channel.comingSoon !== false && (
            <Chip
              size="small"
              label={comingSoonLabel}
              sx={(theme) => ({
                height: 24,
                fontWeight: 700,
                color: theme.palette.text.primary,
                backgroundColor: alpha(channel.color, 0.12),
                border: `1px solid ${alpha(channel.color, 0.24)}`,
              })}
            />
          )}
        </Stack>

        <Box sx={{ flexGrow: 1 }}>
          {planBlocked && <Chip size="small" label={i18n.t('plan_access.professional_required')} sx={{ mb: 1.5 }} />}
          <Typography variant="h5" fontWeight={700} gutterBottom sx={{ letterSpacing: 0 }}>
            {translate(`integrations.channels.${channel.titleKey}`, { defaultValue: channel.titleFallback })}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {translate(`integrations.channels.${channel.descriptionKey}`, {
              defaultValue: channel.descriptionFallback,
            })}
          </Typography>
          {channel.comingSoon !== false && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1.5 }}>
              {translate('integrations.coming_soon_note', {
                defaultValue: 'We are polishing this integration and will enable it soon.',
              })}
            </Typography>
          )}
        </Box>

        <Button
          variant="contained"
          disabled={planBlocked || channel.comingSoon !== false}
          fullWidth
          component={channel.path ? RouterLink : 'button'}
          to={channel.path}
          onClick={channel.onClick || (channel.key === 'whatsapp' ? onWhatsAppConnect : undefined)}
          sx={{ py: 1.2, borderRadius: 1, fontWeight: 700 }}
        >
          {channel.comingSoon === false
            ? translate(`integrations.channels.${channel.actionKey}`, { defaultValue: channel.actionFallback })
            : comingSoonLabel}
        </Button>
      </Stack>
    </Card>
  );
}
